import { render, staticRenderFns } from "./ProfileNotification.vue?vue&type=template&id=4010cbd7&scoped=true"
import script from "./ProfileNotification.vue?vue&type=script&lang=js"
export * from "./ProfileNotification.vue?vue&type=script&lang=js"
import style0 from "./ProfileNotification.vue?vue&type=style&index=0&id=4010cbd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4010cbd7",
  null
  
)

export default component.exports